import { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import { getProductsByUrl } from '../../data-layer/products/service';
import { AddProductDrawer } from '../../ui/posts/AddProductDrawer';
import { ymTrackProductNotFound } from '../../utils/metrika';
import { useBackButton } from '../../utils/useBackButton';
import { useCurrentUser } from '../users/useCurrentUser';

export const AddProductDialog = () => {
    const currentUser = useCurrentUser();
    const { state } = useLocation();
    const { postId } = state;
    const navigate = useNavigate();
    const onNavigateBack = useBackButton();
    const [error, setError] = useState<Error>();

    const [productState, addProduct] = useAsyncFn(
        async (url) => {
            try {
                const product = await getProductsByUrl(url);
                navigate(postId ? `/posts/${postId}/edit` : '/posts/create', {
                    state: { newProduct: product },
                });
            } catch (_err) {
                ymTrackProductNotFound({
                    page: 'Редактирование поста',
                    userLogin: currentUser?.login,
                    businessId: currentUser?.profile?.publicId,
                    value: url,
                });
                const productError = new Error('Товар не найден');
                setError(productError);
                throw productError;
            }
        },
        [currentUser?.login, currentUser?.profile?.publicId],
    );

    const onChangeUrl = useCallback(() => {
        setError(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, setError]);

    return (
        <AddProductDrawer
            handleClose={onNavigateBack}
            addProduct={addProduct}
            loading={productState.loading}
            error={error}
            onChangeUrl={onChangeUrl}
        />
    );
};
